import store from '../store/store';
import { firebase } from '../config/firebase.client';
import { query, onValue, set, off, push, limitToLast, update } from "firebase/database";
import {
    STOP_LOCATION_FETCH,
    FETCH_BOOKING_LOCATION,
    FETCH_BOOKING_LOCATION_SUCCESS,
    FETCH_BOOKING_LOCATION_FAILED,
} from "../store/types";

export const saveTracking = (bookingId, location) => {
    const {
        trackingRef
    } = firebase;
    push(trackingRef(bookingId), location);
}

export const fetchBookingLocations = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: FETCH_BOOKING_LOCATION,
        payload: bookingId,
    });
    onValue(query(trackingRef(bookingId), limitToLast(1)), (snapshot) => {
        if (snapshot.val()) {
            let data = snapshot.val();
            const locations = Object.keys(data)
                .map((i) => {
                    return data[i]
                });
            if (locations.length == 1) {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_SUCCESS,
                    payload: locations[0]
                });
            }
            else {
                dispatch({
                    type: FETCH_BOOKING_LOCATION_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
                });
            }
        } else {
            dispatch({
                type: FETCH_BOOKING_LOCATION_FAILED,
                payload: store.getState().languagedata.defaultLanguage.location_fetch_error,
            });
        }
    });
};

export const stopLocationFetch = (bookingId) => (dispatch) => {

    const {
        trackingRef
    } = firebase;

    dispatch({
        type: STOP_LOCATION_FETCH,
        payload: bookingId,
    });
    off(trackingRef(bookingId));
}

export const saveUserLocation = async (location) => {
    const {
        auth,
        userLocationRef,
    } = firebase;
    const uid = auth.currentUser.uid;
    if (uid) {


        set(userLocationRef(uid), location);

    }
}

export const saveUserCity = async (city) => {
    const {
        auth,
        singleUserRef,
    } = firebase;
    const uid = auth.currentUser.uid;
    if (uid) {
        update(singleUserRef(uid), { city });
    }
}


export const saveUserCostumerLocation = (location) => {
    const {
        auth,
        userlocationsCostumerRef,
    } = firebase;
    const uid = auth.currentUser.uid;
    if (uid) {
        set(userlocationsCostumerRef(uid), location);
    }
}